import { uniq } from 'lodash'
import { schema } from 'prose-core'
import { Node } from 'prosemirror-model'

import { isNodeName } from 'common/Prose/Plugins/TrackChanges/utils'

const TEXT_MAX_LENGTH = 100

const HUMAN_READABLE_NAMES: { [node in keyof typeof schema.nodes]: string } = {
  ai_suggestion: 'AI Suggestion',
  asana_embed: 'Asana embed',
  paragraph: 'Paragraph',
  br: '⮐',
  check_list: 'Check list',
  code_block: 'Code block',
  column_group: 'Columns',
  column: 'Column',
  doc: '',
  download: 'File',
  github_embed: 'Github embed',
  generate_image: 'Generate image',
  heading: 'Heading',
  image: 'Image',
  iframe: 'Embed',
  jira_embed: 'Jira embed',
  line_divider: 'Divider',
  list_item: 'List item',
  mermaid_embed: 'Mermaid embed',
  ordered_list: 'List',
  smartLink: 'Mention',
  table: 'Table',
  table_cell: 'Table cell',
  table_header: 'Table header',
  table_row: 'Table row',
  text: '',
  unordered_list: 'List',
  toggle_list: 'Toggle list',
  table_of_contents: 'Table of contents',
  summary: 'Summary',
  box: 'Callout',
  card: 'Card',
  collection: 'Collection',
  vote_list: 'Vote list',
  vote_list_item: 'Vote list item',
}

const trimText = (text: string, maxLength: number) => {
  if (text.length <= maxLength) {
    return text
  }
  return text.substring(0, maxLength).concat('...')
}

interface Props {
  nodes: Node[]
}

export const MainContent = ({ nodes }: Props) => {
  if (nodes.length === 0) {
    return null
  }
  const firstNode = nodes[0]

  if (nodes.length === 1 && firstNode.type === schema.nodes.image) {
    const { src } = firstNode.attrs
    return (
      <>
        <img alt={src} src={src} style={{ maxHeight: 20 }} /> Image
      </>
    )
  }

  let textContent = uniq(nodes.filter((node) => node.isInline).map((node) => node.textContent)).join(' ')

  // Change is spaces only
  if (textContent.match(/^\s+$/)) {
    textContent = '· (Space)'
  }

  if (textContent !== '') {
    textContent = trimText(textContent, TEXT_MAX_LENGTH)
  }

  const nodeName = isNodeName(firstNode.type.name) ? firstNode.type.name : undefined

  if (!nodeName) {
    return null
  }

  if (firstNode.type === schema.nodes.text) {
    return <span aria-label="change-content">{textContent}</span>
  }

  return (
    <span aria-label="change-content">
      <i>{HUMAN_READABLE_NAMES[nodeName]}</i>
      {textContent !== '' ? `: ${textContent}` : ''}
    </span>
  )
}
